// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"j-","image":"j_","topImage":"ka","fadedIn":"kb"};